<section class="confirm-edit-changes-wrapper">
  <h1>SEND EDITS FOR REVIEW</h1>
  <p>Confirm that each of the edits appear as intended before sending for review.</p>
  @if (auditPending) {
    <div class="audit-pending">
      Audit cannot be created because there is already a pending audit.
    </div>
  }
  @if (awaitingAuditsCall) {
    <app-progress-bar></app-progress-bar>
  }

  <div class="changes-review-table-wrapper">
    <changes-review-table [changesForView]="configData.changes"></changes-review-table>
  </div>
  <div class="edit-doc-changes-note">
    <textarea
      class="default-light-green-ui-input-style"
      [(ngModel)]="auditNote"
      rows="2"
      placeholder="Add note..."
    ></textarea>
  </div>

  <div class="buttons-container">
    <styled-button [styleClass]="'light-gray'" (clickEmitter)="closeModal()">Cancel </styled-button>
    <styled-button
      [styleClass]="'light-green'"
      [disabled]="awaitingAuditsCall || auditPending"
      (clickEmitter)="createAudit()"
      >Send for review
    </styled-button>
  </div>
</section>
